<template>
    <div class="pdf_box">
        <a-spin size="large" tip="Loading..." :spinning="PdftStore.spinning">
            <div class="btn">
                <!-- <a-button @click="changeLanguage">切换为中文报告</a-button> -->
                <a-button @click="gotopath">返回列表</a-button>
                <a-button @click="getpdf">导出</a-button>
            </div>
            <div style="width:1512px;height:34385px" class="pdf" ref="pdf">
                <Page1/>
                <Page2/>
                <Page3/>
                <Page4/>
                <Page5/>
                <Page6/>
                <Page7/>
                <Page8/>
                <Page9/>
                <Page10/>
                <Page11/>
                <Page12/>
                <Page13/>
                <Page14/>
                <Page15/>
                <Page16/>
            </div>
        </a-spin>
    </div>
</template>

<script>
import { reactive, toRefs,ref, onBeforeMount, onMounted, onBeforeUnmount } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { downloadPDF } from '@/utils/pdf.js'
import Page1 from './page/page1.vue'
import Page2 from './page/page2.vue'
import Page3 from './page/page3.vue'
import Page4 from './page/page4.vue'
import Page5 from './page/page5.vue'
import Page6 from './page/page6.vue'
import Page7 from './page/page7.vue'
import Page8 from './page/page8.vue'
import Page9 from './page/page9.vue'
import Page10 from './page/page10.vue'
import Page11 from './page/page11.vue'
import Page12 from './page/page12.vue'
import Page13 from './page/page13.vue'
import Page14 from './page/page14.vue'
import Page15 from './page/page15.vue'
import Page16 from './page/page16.vue'
import { usePdftStore } from '@/store/pdf'
export default {
    name: 'index',
    components:{Page1, Page2, Page3,Page4, Page5, Page6, Page7, Page8, Page9, Page10, Page11, Page12, Page13, Page14, Page15, Page16},
    setup() {
        const route = useRoute()
        const data = reactive({
            id:null,
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const router = useRouter()
        let pdf = ref(null)
        const downloadPDFs = (v,router) => {
            PdftStore.queid = data.id
            return downloadPDF(v,router)
        }
        const getpdf = () => {
            PdftStore.spinning = true
            downloadPDFs(pdf.value,router)
        };
        //获取报告详情
        const getReport = () => {
            let params = {
                id:data.id
            }
            PdftStore.getReport(params)
        }
        const gotopath = () => {
            router.push('/scoring')
        }
        //切换中英文报告
        const changeLanguage = () => {
            router.push({
                path:'/pdf',
                query:{
                    id:data.id
                }
            })
        }

        /**
         * @description: 清空对象
         * @param {*} obj
         * @return {*}
         */
         const resetObj = (obj) => {
            Object.keys(obj).forEach((key) => {
                obj[key] = null
            })
        }

        onBeforeMount(() => {
            data.id = route.query.id;//获取报告id
            getReport()
        })

        onBeforeUnmount(() => {
            resetObj(PdftStore.fromData)
        })
        onMounted(() => {
            
        })
        return {
            pdf,
            getpdf,
            getReport,
            PdftStore,
            gotopath,
            changeLanguage,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.pdf_box{
    width: 100vw;
}
.btn{
    text-align: right;
    margin: 20px;
}
.pdf{
    font-family: PingFangSC-Medium, PingFang SC !important;
    margin: 0 auto;
}
</style>